import {Type} from 'class-transformer';

import {Address} from '@app/shared/classes/address';
import {serializeType} from '@app/shared/classes/common';
import {PartnerContact, TradingPartner} from '@app/shared/classes/trading-partner';
import {PurchaseRequisitionItem} from '@app/shared/classes/purchase-req';
import {ApprovalStatusType} from "@app/shared";


export class PurchaseRequisitionSummary {

  purchaseReqId: number;
  originalPurchaseReqId: number;
  purchaseReqNumber: string;
  revision: number;
  purchaseReqIdRev: string;
  purpose: string;
  vendorName: string;
  purchaseOrderId: number;
  purchaseOrderNumber: string;
  deliveryDate: string;
  amount: number;
  currentStatus: string;
}


export class PurchaseOrder {

  id: number;
  version: number;
  purchaseOrderNumber: string;
  @Type(serializeType(Date)) sentOn?: Date;
  purchaseReqId?: number;
  sentById: number;
  vendorId: number;
  shipToId: number;
  billToId: number;
  contactId: number;

  @Type(serializeType(PurchaseRequisitionItem)) purchaseOrderItems: PurchaseRequisitionItem[];
  @Type(serializeType(Address)) billToAddress?: Address;
  @Type(serializeType(Address)) shipToAddress?: Address;
}

export class PurchaseRequisition {
  id: number;
  purchaseReqNumber: string;
  version: number;
  originalPurchaseReqId: number;
  revision: number;

  requisitionTypeId: number;
  requisitionTypeName: string;

  submittedForId: number;

  submittedById: number;
  submittedBy: string;

  defaultChargeCode: string;
  prTemplate: string;

  requestedDelivery: string;
  requiredDelivery: string;
  popFrom: string;
  popThru: string;

  shippingType: string;
  buyerLocation: string;
  currencyType: string;
  purchReqType: string;
  purpose: string;
  requisitionDescription: string;
  currentStatusName?: ApprovalStatusType;
  hasSubmissionError?: boolean;
  vendorName: string;

  subTotalAmount: number;
  taxAmount: number;
  taxRate: number;
  shippingAmount: number;
  totalReqAmount: number;

  prreqPdfTemplateId: number;
  prordPdfTemplateId: number;

  purchaseOrderId: number;
  purchaseOrderNumber: string;

  vendorId: number;
  @Type(serializeType(TradingPartner)) vendor: TradingPartner;

  contactId: number;
  @Type(serializeType(Address)) vendorAddressDetail: Address;
  @Type(serializeType(PartnerContact)) contactDetail: PartnerContact;

  shipToId: number;
  @Type(serializeType(Address)) shipToAddressDetail: Address;

  billToId: number;
  @Type(serializeType(Address)) billToAddressDetail: Address;

  @Type(serializeType(PurchaseRequisitionItem)) purchaseRequisitionItems: Array<PurchaseRequisitionItem> = [];
  billToSameAsShipTo: boolean;
}